import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'sst-change-location';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Change location',
};

const sstChangeLocation = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { sstChangeLocation };
